<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always;"></div>
<p class="P_Normal__And__Page_Break" id="auto_bookmark_table_of_contents_1"><span style=" font-weight: bold; font-size: 1.00em; text-transform: uppercase;">JULIA TALBOT</span> vit dans le grand sud-ouest, là où l’on trouve du rodéo, des cowboys et toute la viande et les pommes de terre du meilleur des Tex-mex. Auteur à plein temps, Julia a été publiée par Torquere Press, Dreamspinner et Changeling Press. Elle croit que tout le monde mérite une fin heureuse, alors, elle écrit sur l’amour sans limites, où des garçons aiment des garçons, des filles aiment des filles et les garçons et les filles se rassemblent pour s’aimer sauvagement, surtout lorsque ses personnages paranormaux et fous sont impliqués. Retrouvez Julia sur @juliatalbot sur Twitter, ou sur www.juliatalbot.com.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?5592c871